import { Component, h, Host, Prop, Watch, Element } from '@stencil/core';
import { ActionTrackingEvent } from '@union-investment/tracking/src/events';
import { DEFAULT_TRACKING_DELAY, delayPageChange } from '../../../global/utility/tracking-helpers';

export interface UiCmsContactChannelsEmailBody {
  buttonTitle: string;
  emailAddress: string;
  headline: string;
  text: string;
}

@Component({
  tag: 'ui-cms-contact-channels-email',
  styleUrl: 'ui-cms-contact-channels-email.scss',
})
export class UiCmsContactChannelsEmail {
  @Element() el: HTMLUiCmsContactChannelsEmailElement;

  @Prop({ mutable: true }) body: UiCmsContactChannelsEmailBody = {} as any;

  @Prop({ attribute: 'body' }) utilityBody: string;

  @Prop() inverted: boolean;

  @Watch('utilityBody')
  bodyChangeHandler(newValue: string) {
    this.body = newValue ? JSON.parse(newValue) : this.body;
  }

  componentWillLoad() {
    this.bodyChangeHandler(this.utilityBody);
  }

  onLinkClick(event: Event, link: HTMLAnchorElement) {
    delayPageChange(DEFAULT_TRACKING_DELAY, event, link);
    const trackingEvent: ActionTrackingEvent = {
      eventInfo: {
        eventName: 'Contact Email',
        eventType: 'Action',
        eventCaller: this.el,
      },
      attributes: {
        elementType: 'Link',
        elementLabel: this.body.emailAddress,
        externalTarget: this.body.emailAddress,
      },
      category: {
        area: 'Content',
      },
    };

    if (trackingEvent) {
      window.ui?.services?.tracking?.track(trackingEvent);
    }
  }

  onButtonClick() {
    const trackingEvent: ActionTrackingEvent = {
      eventInfo: {
        eventName: 'Contact Email',
        eventType: 'Action',
        eventCaller: this.el,
      },
      attributes: {
        elementType: 'Link',
        elementLabel: this.body.buttonTitle,
        externalTarget: this.body.emailAddress,
      },
      category: {
        area: 'Content',
      },
    };

    if (trackingEvent) {
      window.ui?.services?.tracking?.track(trackingEvent);
    }
  }

  render() {
    const mail = `mailto:${this.body.emailAddress}`;

    return (
      <Host class="channel">
        <div class="channel-contactbox">
          <div class="up">
            <h4
              class={{
                'sd-headline': true,
                'sd-headline--inline': true,
                'sd-headline--size-3xl': true,
                'sd-headline--inverted': this.inverted,
              }}
            >
              <sd-icon
                library={window.ui.cmsState.iconLibrary}
                name="union-investment/content/letter-sent"
                color={this.inverted ? 'white' : 'primary'}
              ></sd-icon>
              <span innerHTML={this.body.headline}></span>
            </h4>
            <p
              class={{ copy: true, 'sd-paragraph': true, 'sd-paragraph--inverted': this.inverted }}
              innerHTML={this.body.text}
            ></p>
            <sd-link
              inverted={this.inverted}
              itemProp="email"
              size="inherit"
              href={mail}
              target="_blank"
              onClick={(event: Event) => this.onLinkClick(event, event.currentTarget as HTMLAnchorElement)}
            >
              <span innerHTML={this.body.emailAddress}></span>
            </sd-link>
          </div>
          <div class="down">
            <sd-button
              itemProp="email"
              href={mail}
              target="_blank"
              onClick={this.onButtonClick.bind(this)}
              className="button"
              variant="primary"
              inverted={this.inverted}
              size="lg"
              type="button"
            >
              {this.body.buttonTitle}
            </sd-button>
          </div>
        </div>
      </Host>
    );
  }
}
